import IpubUploadCropper from './src/main.vue'

/* istanbul ignore next */
IpubUploadCropper.install = function(Vue) {
  Vue.component(IpubUploadCropper.name, IpubUploadCropper)
}

export default IpubUploadCropper
